var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { QueryColumn } from "@easyquery/core";
import { lcv } from '../utils/lcv';
var QueryColumnEx = /** @class */ (function (_super) {
    __extends(QueryColumnEx, _super);
    function QueryColumnEx() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.readOnly = false;
        return _this;
    }
    QueryColumnEx.prototype.isReadOnly = function () {
        return this.readOnly;
    };
    QueryColumnEx.prototype.setReadOnly = function (value) {
        this.readOnly = value;
    };
    /**
     * Loads column from its JSON representation object.
     * @param model The Data Model.
     * @param colData The JSON representation object.
     */
    QueryColumnEx.prototype.loadFromData = function (model, colData) {
        _super.prototype.loadFromData.call(this, model, colData);
        if (lcv.__kt <= 2)
            return;
        if (colData) {
            if (typeof colData.readOnly != 'undefined') {
                this.readOnly = colData.readOnly;
            }
        }
    };
    QueryColumnEx.prototype.saveToData = function () {
        var colData = _super.prototype.saveToData.call(this);
        if (lcv.__kt <= 2)
            return colData;
        if (this.isReadOnly()) {
            colData.readOnly = this.isReadOnly();
        }
        return colData;
    };
    return QueryColumnEx;
}(QueryColumn));
export { QueryColumnEx };
//# sourceMappingURL=query_column_ex.js.map